import type { CourseModule } from "@/core/types";
import { lektionDropdowns } from "./lektion-01-dropdowns";
import { lektionPruefregeln } from "./lektion-02-regeln";

export const modulDatenueberpruefung: CourseModule = {
  id: "datenueberpruefung",
  title: "Datenüberprüfung und Dropdowns",
  summary:
    "Fehler dort verhindern, wo sie entstehen: bei der Eingabe. Auswählen statt " +
    "tippen, Grenzen statt Hoffnung.",
  level: "Aufbau",
  lessons: [lektionDropdowns, lektionPruefregeln],
};
